import {
  CREATE_ORGANZIOR_FAILURE,
  CREATE_ORGANZIOR_REQUEST,
  CREATE_ORGANZIOR_SUCCESS,
  GET_ORGANZIOR_FAILURE,
  GET_ORGANZIOR_REQUEST,
  GET_ORGANZIOR_SUCCESS,
  UPDATE_ORGANIZER_FAILURE,
  UPDATE_ORGANIZER_REQUEST,
  UPDATE_ORGANIZER_SUCCESS,
} from "./type";

import api from "../../services/api";
import { trackPromise } from "react-promise-tracker";
import { Details } from "@mui/icons-material";

export const getOrganizor = () => {
  return async (dispatch) => {
    dispatch({ type: GET_ORGANZIOR_REQUEST });
    try {
      const response = await api.get("/event-organizer");
      dispatch({ type: GET_ORGANZIOR_SUCCESS, payload: response.data.data });
    } catch (error) {
      dispatch({ type: GET_ORGANZIOR_FAILURE, payload: error.message });
    }
  };
};

export const createOrganizor = (organizer) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_ORGANZIOR_REQUEST });
    try {
      const response = await api.post("/event-organizer", organizer);
      dispatch({ type: CREATE_ORGANZIOR_SUCCESS, payload: response.data.data });
    } catch (error) {
      dispatch({ type: CREATE_ORGANZIOR_FAILURE, payload: error.message });
    }
  };
};

export const updateOrganizer = (organizer, image) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_ORGANIZER_REQUEST });
    try {
      const response = await trackPromise(
        api.patch(`/event-organizer/${organizer.id}`, {
          details: organizer.details,
          fullname: organizer.fullname,
          image: image,
        })
      );
      dispatch({ type: UPDATE_ORGANIZER_SUCCESS, payload: response.data.data });
    } catch (error) {
      dispatch({ type: UPDATE_ORGANIZER_FAILURE, payload: error.message });
    }
  };
};
